module["exports"] = [
  "Johansson",
  "Andersson",
  "Karlsson",
  "Nilsson",
  "Eriksson",
  "Larsson",
  "Olsson",
  "Persson",
  "Svensson",
  "Gustafsson"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/name/last_name.js
 ** module id = 998
 ** module chunks = 0
 **/